export default __webpack_public_path__ + "static/media/Boots of Illuminant Conviction.6fb58a3d.jpg";